export default {
  MEMBER_LOAD_DATA: 'MEMBER_LOAD_DATA',
  MEMBER_LOAD_DONE: 'MEMBER_LOAD_DONE',
  MEMBER_LOAD_CAMPAIGN: 'MEMBER_LOAD_CAMPAIGN',
  MEMBER_LOAD_CAMPAIGN_DONE: 'MEMBER_LOAD_CAMPAIGN_DONE',
  MEMBER_LOAD_HISTORY: 'MEMBER_LOAD_HISTORY',
  MEMBER_LOAD_HISTORY_DONE: 'MEMBER_LOAD_HISTORY_DONE',
  SELECT_CAMPAIGN: 'SELECT_CAMPAIGN',
  MEMBER_LEVEL_LOAD: 'MEMBER_LEVEL_LOAD', 
  MEMBER_LEVEL_LOAD_DONE: 'MEMBER_LEVEL_LOAD_DONE' 
}
